<div
	class="NetfirmLogin-container"
	[ngClass]="{
		'full-height': !showFooter || isMigrated,
		justify: !showFooter,
		'negative-margin': showFooter && region === 'ca'
	}"
>
	<netfirm-login-banner [isToast]="true"></netfirm-login-banner>
	<router-outlet></router-outlet>
	<netfirm-login-footer
		*ngIf="showFooter && region === 'ca'"
		[enableSelectButton]="true"
		[selectButtonOptions]="supportedLanguages"
		[selectedOption]="currentLanguage"
		(selectButtonChange)="switchLanguage($event)"
	>
	</netfirm-login-footer>
</div>
